export default __webpack_public_path__ + "static/media/img2.f43c1c3f.png";